import type { Element as XmlEl } from "@xmpp/xml"

/** Its own class so the boundary can tell bad input from our own bugs. */
export class InvalidStanza extends Error {
  constructor(
    message: string,
    readonly stanza: XmlEl
  ) {
    super(`${message}\n${stanza.toString()}`)
    this.name = "InvalidStanza"
  }
}

export class UnsupportedEventStanza extends Error {
  constructor(
    message: string,
    readonly stanza: XmlEl
  ) {
    super(`${message}\n${stanza.toString()}`)
    this.name = "UnsupportedEventStanza"
  }
}
